import styled from 'styled-components';

import { Box, Button, TableCell, Typography } from '@mui/material';
import { colorTheme } from '@styles/muiTheme';
import { TextInputField } from '@shared/fields/TextInputField';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';

export const ConditionsContainer = styled.div`
  && {
    background: ${colorTheme.palette.secondary.light};
    border-radius: 8px;
    overflow: hidden;
  }
`;

export const ConditionsBoxShadow = styled.div`
  box-shadow: 0px -4px 1px 0px;
`;

export const GridWrapper = styled.div`
  min-height: 180px;
`;

export const StyledTableCell = styled(TableCell)`
  border: 1px solid ${colorTheme.palette.grey[500]};
`;

export const PitchText = styled.div`
  margin: 10px;
  width: 65%;
  display: flex;
  justify-content: space-between;
`;

export const FormTitle = styled.span`
  color: ${colorTheme.palette.primary.dark};
  font-weight: 700;
  font-size: 15px;
`;

export const FedexLabelFormWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
  div.top-check-feilds input[type='checkbox'] {
    height: 15px;
    width: 15px;
    margin-right: 8px;
    vertical-align: middle;
  }
  div.top-check-feilds span {
    margin-bottom: 3px;
    vertical-align: middle;
  }
`;

export const FedexTypography = styled(Typography)`
  color: ${colorTheme.palette.common.white};
  font-weight: bold;
  margin-bottom: 10px;
`;

export const OuterFedexBoxWrapper = styled(Box)`
  display: inline-block;
  width: 33%;
`;

export const FedexFirstInnerWrapper = styled(OuterFedexBoxWrapper)`
  width: 50%;
`;

export const FedexSecondInnerWrapper = styled(Box)`
  display: inline-block;
  width: 50%;
  font-size: 14px;
  font-weight: bold;
`;

export const DealcalcErrModalWrapper = styled(Box)`
  display: flex;
  align-items: center;
  height: 100px;
`;

export const FedexHistoryBox = styled(Box)`
  position: relative;
  top: -15px;

  input {
    height: 15px;
    width: 15px;
    vertical-align: middle;
    margin-right: 7px;
  }
`;

export const LenderDropDown = styled.div`
  position: relative;

  div.MuiOutlinedInput-root {
    background-color: ${colorTheme.palette.common.white};
    padding: 6px 0 0 5px;
    margin-top: 0px;
  }
`;

export const ValuationGrid = styled(Box)`
  margin-bottom: 10px;

  & div.heighlightDefaultValuation{
	  background-color: ${colorTheme.palette.grey[400]};
  }
`;

export const StyledCommentTextField = styled(TextInputField)`
  margin-bottom: 20px;

  .MuiInputBase-root {
    border: 1px solid ${colorTheme.palette.secondary.main};
    resize: both;
  }
`;

export const DealsPhoenixGrid = styled(PhoenixGrid)`
  & .MuiDataGrid-row.Mui-selected {
    background-color: ${colorTheme.palette.success.light};
  }
`;

export const TrackingNumberText = styled(Button)`
  color: ${colorTheme.palette.primary.light};
  padding-left: 0;
  .MuiButton-textPrimary {
    font-weight: 500;
  };
`;
